import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setCookies } from '../hooks/useCookies';
import { SERVER_URL } from './apiConstants';
import defaultImg from '../assets/user_default.svg';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const profileedit = 'profile-edit';
export const ProfileEdits = createAsyncThunk('api/profileedit', async (data) => {
  const body = {
    token: data.token,
    userid: data.userid,
    email: data.email,
    phone: data.phone,
    name: data.name,
    businessName: data.businessName,
  };
  return axios
    .post(`${SERVER_URL}/${profileedit}`, body, { headers })
    .then((response) => {
      if (response.status === 201 || response.status === 201) {
        setCookies('USERNAME', data.name);
        if (response.data?.data?.user?.image) {
          setCookies('PROFILE', response.data?.data?.user?.image);
        } else {
          setCookies('PROFILE', defaultImg);
        }
      }
      return response.data;
    })
    .catch((e) => e);
});

const profileEditSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    ProfileEditData: {},
    error: '',
  },
  extraReducers: {
    [ProfileEdits.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [ProfileEdits.fulfilled]: (state, action) => {
      state.loading = false;
      state.ProfileEditData = action.payload;
      // Toast shown only in the Settings profile component to avoid duplicate messages
    },
    [ProfileEdits.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      // Error shown only in the Settings profile component to avoid duplicate messages
    },
  },
});

export default profileEditSlice.reducer;
